export default __webpack_public_path__ + "static/DW-Google-Lime-a72aac26acc3e94e0b0d96561f68c1f8.svg";